import { createGetKeyIdentifier, unhardenDerivationIndex } from '@exodus/key-utils'
import assert from 'minimalistic-assert'

const createEthereumGetKeyIdentifier =
  ({ bip44, assetName, keyType = 'secp256k1', allowMetaMaskCompat = false } = {}) =>
  (partialParams = {}) => {
    const params = {
      purpose: 44,
      chainIndex: 0,
      accountIndex: 0,
      addressIndex: 0,
      ...partialParams,
    }

    const { accountIndex, addressIndex, compatibilityMode } = params
    const unhardenedBip44 = unhardenDerivationIndex(bip44)
    const isMetaMask = allowMetaMaskCompat && compatibilityMode === 'metamask'

    if (isMetaMask) {
      assert(addressIndex === 0, 'MetaMask compatibility does not support setting an addressIndex')
      return {
        assetName,
        derivationAlgorithm: 'BIP32',
        derivationPath: `m/44'/${unhardenedBip44}'/0'/0/${accountIndex}`,
        keyType,
      }
    }

    return createGetKeyIdentifier({
      bip44,
      assetName,
      keyType,
      validationRules: {
        allowMultipleAddresses: true,
        allowXPUB: true,
      },
    })(params)
  }

export default createEthereumGetKeyIdentifier
